export const advancedMetastaticDiseaseOptions = [
  {
    label: 'questionnaire.questions.treatment_for_advanced_metastatic_disease.options.yes',
    value: 'yes',
  },
  {
    label: 'questionnaire.questions.treatment_for_advanced_metastatic_disease.options.no',
    value: 'no',
  },
  {
    label: 'questionnaire.questions.treatments.options.i_dont_know',
    value: 'i_dont_know',
  },
];

export const metastaticId = 'treatment_for_advanced_metastatic_disease';
